export const MESSAGE_COLOR_OPERATOR_DARK = "operator-dark";
export const MESSAGE_COLOR_COMMENT_OPERATOR_DARK = 'comment-operator-dark';
export const MESSAGE_COLOR_OPERATOR_COMMENT = 'operator-comment';